(function Index($, Adzuki)
{
	"use strict";

	$(document).ready(function onReady()
	{
		Adzuki.onload(['main/hub'], function onload()
		{
			$('.bookmark-section-items').click(function toggleIcons(e) {
				var is_active = $(this).hasClass('active');

				e.preventDefault();

				if (is_active === false) {
					// toggle the actions on
					$(this).addClass('active');
					$('.section-items').addClass('manage-items');

					$(".section-item-action").each(function showActions() {
						var $element = $(this);

						if ($element.data('bookmarked') === 1 && $element.hasClass('remove-item')) {
							// currently bookmarked, show remove icon
							$element.removeClass('hidden');
						} else if ($element.data('bookmarked') === 0 && $element.hasClass('add-item')) {
							// not bookmarked, show add icon
							$element.removeClass('hidden');
						}
					});
				} else {
					// toggle actions off
					$(this).removeClass('active');
					$('.section-items').removeClass('manage-items');

					$(".section-item-action").each(function showActions() {
						var $element = $(this);

						$element.addClass('hidden');
					});
				}
			});

			$('.bookmark-related-section-items').click(function toggleIcons(e) {
				var is_active = $(this).hasClass('active');

				e.preventDefault();

				if (is_active === false) {
					// toggle the actions on
					$(this).addClass('active');

					$(".related-section-item-action").each(function showActions() {
						var $element = $(this);

						if ($element.data('bookmarked') === 1 && $element.hasClass('remove-item')) {
							// currently bookmarked, show remove icon
							$element.removeClass('hidden');
						} else if ($element.data('bookmarked') === 0 && $element.hasClass('add-item')) {
							// not bookmarked, show add icon
							$element.removeClass('hidden');
						}
					});
				} else {
					// toggle actions off
					$(this).removeClass('active');

					$(".related-section-item-action").each(function showActions() {
						var $element = $(this);

						$element.addClass('hidden');
					});
				}
			});

			// add bookmark
			$(document.body).on('click', '.add-item', function saveBookmark() {
				var $element = $(this);
				var id       = $element.data('section_item_id');

				Adzuki.Ajax.post(
					'/Shortcuts/saveBookmark/', 
						{
							id: id
						}
				)
				.then(function saveResults(response)
				{
					if (response.success) {
						$element.attr('data-bookmarked', 1);
						$element.data('bookmarked', 1);
						$element.next('.remove-item').attr('data-bookmarked', 1);
						$element.next('.remove-item').data('bookmarked', 1);

						_toggleIcons($element);

						Adzuki.StatusMessage('Success', 'You have added ' + response.total + ' of 20 shortcuts');
					} else {
						Adzuki.StatusMessage('Error', response.message);
					}
				})
				.catch(function saveError()
				{
					Adzuki.StatusMessage('Error', 'Unable to save shortcut.');
				});
			});

			// remove bookmark
			$(document.body).on('click', '.remove-item', function removeBookmark() {
				var $element = $(this);
				var id       = $element.data('section_item_id');

				Adzuki.CustomConfirm({
					body   : 'Are you sure you wish to delete this shortcut?',
					confirm: function agentConfirm() {
						Adzuki.Ajax.post(
							'/Shortcuts/removeBookmark/', 
								{
									id: id
								}
						)
						.then(function saveResults(response)
						{
							if (response.success) {
								$element.attr('data-bookmarked', 0);
								$element.data('bookmarked', 0);
								$element.prev('.add-item').attr('data-bookmarked', 0);
								$element.prev('.add-item').data('bookmarked', 0);
		
								_toggleIcons($element);

								Adzuki.StatusMessage('Success', 'Shortcut removed.');
							} else {
								Adzuki.StatusMessage('Error', response.message);
							}
						})
						.catch(function saveError()
						{
							Adzuki.StatusMessage('Error', 'Unable to remove shortcut.');
						});
					}
				});
			});
		});

		function _toggleIcons($element)
		{
			if ($element.hasClass('section-item-action')) {
				$(".section-item-action").each(function showActions() {
					var $element = $(this);

					if ($element.data('bookmarked') === 1 && $element.hasClass('remove-item')) {
						// currently bookmarked, show remove icon
						$element.removeClass('hidden');
					} else if ($element.data('bookmarked') === 0 && $element.hasClass('add-item')) {
						// not bookmarked, show add icon
						$element.removeClass('hidden');
					} else {
						$element.addClass('hidden');
					}
				});
			} else if ($element.hasClass('related-section-item-action')) {
				$(".related-section-item-action").each(function showActions() {
					var $element = $(this);

					if ($element.data('bookmarked') === 1 && $element.hasClass('remove-item')) {
						// currently bookmarked, show remove icon
						$element.removeClass('hidden');
					} else if ($element.data('bookmarked') === 0 && $element.hasClass('add-item')) {
						// not bookmarked, show add icon
						$element.removeClass('hidden');
					} else {
						$element.addClass('hidden');
					}
				});
			}
		}
	});
}(jQuery, window.Adzuki || {}));